import { makeStyles } from "@material-ui/core";
import {
	DEFAULT_BOX_SHADOW,
	PRIMARY_BACKGROUND,
	instance2,
} from "App/constants";
import { today } from "App/utils/helpers";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlPostBundleHeader = "/satu-sehat/condition/create-bundle-header";
export const urlPostBundleDetail = "/satu-sehat/condition/create-bundle-detail";
export const urlPostBundleProses = "/satu-sehat/condition/proses-kirim";

export const urlGetBundleHeader = "/satu-sehat/condition/list-bunde-header";
export const urlDeleteBundle = "/satu-sehat/condition/delete-bunde-header";
export const urlGetKunjungan = "/satu-sehat/condition/asha-registrasi";
export const urlGetDetailHeader = "/satu-sehat/condition/list-bunde-detail";

export const STYLE_MASTER_SATU_BUNDLE = makeStyles({
	root: {
		width: "auto",
	},
	paper: {
		width: "100%",
		margin: "0",
		padding: "1rem 1.5rem",
		backgroundColor: PRIMARY_BACKGROUND,
		boxShadow: DEFAULT_BOX_SHADOW,
	},
	table: {
		width: "100%",
		margin: "0 auto",
		overflow: "auto",
	},
});

export const BUTTON_SUBMIT = {
	label: "SIMPAN",
	color: "lightgreen",
	state: false,
	disabled: false,
};

export const headCellsHeader = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: false,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "id_bundle",
		disablePadding: false,
		label: "ID BUNDLE",
		align: "center",
		minWidth: "20px",
	},
	{
		id: "request",
		disablePadding: false,
		label: "REQUEST",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "response",
		disablePadding: false,
		label: "RESPONSE",
		align: "center",
		minWidth: "120px",
	},
	{
		id: "inserted_user",
		disablePadding: false,
		label: "INSERTED USER",
		align: "center",
		minWidth: "150px",
	},
	{
		id: "inserted_date",
		disablePadding: false,
		label: "INSERTED DATE",
		align: "center",
		minWidth: "100px",
	},
];

export const RESET_STATE_HEADER = {
	id_bundle: "",
	request: "",
	response: "",
	inserted_user: "",
	inserted_date: "",
	inserted_ip: "",
	updated_user: "",
	updated_date: "",
	updated_ip: "",
	deleted_user: "",
	deleted_date: "",
	tglAwal: "",
	tglAkhir: "",
	deleted_ip: "",
	keterangan: "",
	pages: 1,
	limit: 10,
};

export const RESET_STATE_KUNJUNGAN = {
	id_kunjungan: "",
	nama_pasien: "",
	no_rm: "",
	id_ihs: "",
	instalasi: "",
	id_dokter: "",
	nama_dokter: "",
	participant: "",
	id_spesialist: "",
	dokter: "",
	periode_mulai: "",
	periode_selesai: "",
	asmed: "",
	status_history_arrive: "",
	status_history_inprogress: "",
	status_history_finish: "",
	id_ases_medis: "",
	id_ases_perawat: "",
	poli_code: "",
	nama_poliklinik: "",
	id_poliklinik: "",
	id_location: "",
	kode: "",
	name: "",
	description: "",
	status: "",
	tglAwal: today(),
	tglAkhir: today(),
	pages: 1,
	limit: 10,
};

export const RESET_STATE_DETAIL = {
	id_bundle_detail: "",
	id_bundle: "",
	id_kunjungan: "",
	nama_pasien: "",
	no_rm: "",
	instalasi: "",
	nama_dokter: "",
	participant: "",
	dokter: "",
	periode_mulai: "",
	periode_selesai: "",
	id_location: "",
	location: "",
	condition: {
		diagnosa: [],
	},
	status_history_arrive: "",
	status_history_inprogress: "",
	status_history_finish: "",
	request: "",
	response: "",
	fullurl_kunjungan: "",
	fullurl_askep: "",
	fullurl_asmed: "",
	inserted_user: "",
	inserted_date: "",
	inserted_ip: "",
	updated_user: "",
	updated_date: "",
	updated_ip: "",
	deleted_user: "",
	deleted_date: "",
	deleted_ip: "",
	id_ihs: "",
	tglAwal: "",
	tglAkhir: "",
	pages: 1,
	limit: 10,
};

export const headCellsKunjungan = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: false,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "id_kunjungan",
		disablePadding: false,
		label: "ID KUNJUNGAN",
		align: "center",
		minWidth: "20px",
	},
	{
		id: "nama_pasien",
		disablePadding: false,
		label: "NAMA PASIEN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "no_rm",
		disablePadding: false,
		label: "NO. RM",
		align: "center",
		minWidth: "120px",
	},
	{
		id: "instalasi",
		disablePadding: false,
		label: "INSTALASI",
		align: "center",
		minWidth: "150px",
	},
	{
		id: "nama_dokter",
		disablePadding: false,
		label: "DOKTER",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "dokter",
		disablePadding: false,
		label: "SPESIALIS",
		align: "center",
		minWidth: "100px",
	},
];

export const headCellsDetail = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: false,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "id_bundle_detail",
		disablePadding: false,
		label: "ID BUNDLE DETAIL",
		align: "center",
		minWidth: "20px",
	},
	{
		id: "id_kunjungan",
		disablePadding: false,
		label: "ID KUNJUNGAN",
		align: "center",
		minWidth: "20px",
	},
	{
		id: "nama_pasien",
		disablePadding: false,
		label: "NAMA PASIEN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "no_rm",
		disablePadding: false,
		label: "NO. RM",
		align: "center",
		minWidth: "120px",
	},
	{
		id: "instalasi",
		disablePadding: false,
		label: "INSTALASI",
		align: "center",
		minWidth: "150px",
	},
	{
		id: "nama_dokter",
		disablePadding: false,
		label: "DOKTER",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "dokter",
		disablePadding: false,
		label: "SPESIALIS",
		align: "center",
		minWidth: "100px",
	},
];

export const getBundle = async (formFilter, pages, limit) => {
	try {
		const api = await instance2.get(
			`${urlGetBundleHeader}?tglAwal=${startOfDay(
				formFilter.tglAwal
			)}&tglAkhir=${lastOfDay(
				formFilter.tglAkhir
			)}&limit=${limit}&pages=${pages}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			data: res.data,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const getKunjungan = async (formFilter, pages, limit) => {
	try {
		const api = await instance2.get(
			`${urlGetKunjungan}?tglAwal=${startOfDay(
				formFilter.tglAwal
			)}&tglAkhir=${lastOfDay(
				formFilter.tglAkhir
			)}&limit=${limit}&pages=${pages}&id_kunjungan=${
				formFilter.id_kunjungan
			}&id_dokter=${formFilter.id_dokter}&no_rm=${
				formFilter.no_rm
			}&nama_pasien=${formFilter.nama_pasien}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			data: res.data,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const getDetailHeader = async (formFilter, pages, limit) => {
	try {
		const api = await instance2.get(
			`${urlGetDetailHeader}?tglAwal=${startOfDay(
				formFilter.tglAwal
			)}&tglAkhir=${lastOfDay(
				formFilter.tglAkhir
			)}&limit=${limit}&pages=${pages}&id_bundle=${formFilter.id_bundle}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			data: res.data,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const postBundleHeader = async (keterangan) => {
	try {
		const api = await instance2.post(`${urlPostBundleHeader}`, {
			keterangan: keterangan,
		});
		const res = api.data;

		return {
			status: true,
			message: res.message,
			data: res.data,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const postBundleDetail = async (
	id_bundle,
	id_kunjungan,
	nama_pasien,
	no_rm,
	id_ihs,
	instalasi,
	nama_dokter,
	participant,
	dokter,
	periode_mulai,
	periode_selesai,
	id_location,
	location,
	condition,
	fullurl_kunjungan,
	fullurl_askep,
	fullurl_asmed,
	status_history_arrive,
	status_history_inprogress,
	status_history_finish
) => {
	try {
		const api = await instance2.post(`${urlPostBundleDetail}`, {
			id_bundle: id_bundle,
			id_kunjungan: id_kunjungan,
			nama_pasien: nama_pasien,
			no_rm: no_rm,
			id_ihs: id_ihs,
			instalasi: instalasi,
			nama_dokter: nama_dokter,
			participant: participant,
			dokter: dokter,
			periode_mulai: periode_mulai,
			periode_selesai: periode_selesai,
			id_location: id_location,
			location: location,
			condition: condition,
			fullurl_kunjungan: fullurl_kunjungan,
			fullurl_askep: fullurl_askep,
			fullurl_asmed: fullurl_asmed,
			status_history_arrive: status_history_arrive,
			status_history_inprogress: status_history_inprogress,
			status_history_finish: status_history_finish,
		});
		const res = api.data;

		return {
			status: true,
			message: res.message,
			data: res.data,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const postBundleProses = async (id_bundle) => {
	try {
		const api = await instance2.post(`${urlPostBundleProses}`, {
			id_bundle: id_bundle,
		});
		const res = api.data;

		return {
			status: true,
			message: res.message,
			data: res.data,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};
